module.exports = "img/flags/FO.5b948c0.png";